import axios from "axios";
import { urls } from "../../config/constants";

const getInvitationById = async (id) => {
  try {
    const response = await axios.get(`${urls.api}/invitations?id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

export { getInvitationById };
